__webpack_require__.p = "/headers/admin/product_decision/scr_notifications_tool/";